import React from 'react'
import AdminComplaints from '../../components/AdminComplaints/AdminComplaints'

export default function AdminComplaintPage() {
  return (
    <AdminComplaints/>
  )
}
   